import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { QsPreview } from '@/components'
let { WizContainer } = framework_tool
let { WizSpin } = component_tool
let { Session } = utils_tool

const getParamRecord = (history) => {
    let record = {}
    if (history.location &&
        (history.location.pathname === '/biz/survey/surveyPreview'
        || history.location.pathname === '/featured/management/featuredLook/featuredSurvey')) {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('surveyPreview', record)
        } else {
            record = Session.get('surveyPreview') || {}
        }
    }
    return record
}

class SurveyPreview extends WizContainer {

    componentName = 'SurveyPreview'

    constructor(props) {
        super(props)
        let { history } = props
        this._survey = getParamRecord(history)
        this.state = {
            surveyId: this._survey.id
        }
    }

    _componentDidMount() {
        this.doAction({
            path: 'survey/getSurveyInfo',
            payload: {
                key: 'surveyPreview_' + this.state.surveyId,
                apiParams: { id: this.state.surveyId }
            }
        })
    }

    // _onSubmit = () => {
    //     WizNotice.warn('当前为问卷预览页面，只能预览，不能提交！')
    // }

    _render() {
        let { code, data } = this.props.surveyPreview
        if (code !== 1) {
            data = {
                title: this._survey.title,
                intro: this._survey.intro
            }
        }
        return (
            <>
                <WizSpin tip={'加载中'} spinning={this.props.surveyLoading}>
                    <QsPreview data={ { ...data, preview: true } }
                               // onSubmit={this._onSubmit}
                    />
                </WizSpin>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { survey } = state
    const { history } = ownProps
    let record = getParamRecord(history)
    const surveyPreview = modelUtils.getModelEntity(survey, 'surveyPreview_' + record.id)
    const load = modelUtils.getLoadingState(state, 'survey')
    return {
        surveyPreview,
        ...load
    }
}

export default connect(mapStateToProps)(SurveyPreview)
